import util from 'meinian-package/src/utils/util'

const urlSource = {
  '/meinian/home/workbench/index': '工作台',
  // '/meinian/home/coll/index': '灵感集',
  '/meinian/home/all': '款式图库',
  '/meinian/home/sample': '样衣管理',
  '/meinian/home/category-tags': '分类标签',
  '/meinian/home/style-trend': '款式动态',
  '/meinian/home/intellectRecommend': '智能选款',
  '/meinian/home/analysis/choose': '选款分析',
  '/meinian/home/recycle': '回收站',
}
export default () => {
  if (urlSource?.[location.pathname]) {
    util.track('mn-inspiration-sidebar-page', {
      module1: urlSource?.[location.pathname],
    })
  }
}
